import React from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const AIMasteryGuarantee = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bgGradient="linear(to-br, accent.green, green.600)">
      <Container maxW="container.lg">
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <VStack spacing={8} textAlign="center">
            {/* Icon */}
            <Box
              p={6}
              bg="whiteAlpha.200"
              borderRadius="full"
            >
              <Icon
                as={data.icon}
                boxSize={16}
                color="white"
              />
            </Box>

            {/* Title */}
            <Heading
              size="2xl"
              fontWeight="900"
              color="white"
            >
              {data.title}
            </Heading>

            {/* Description */}
            <Text
              fontSize="xl"
              color="whiteAlpha.900"
              maxW="3xl"
            >
              {data.description}
            </Text>

            {/* Features */}
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} w="full" pt={4}>
              {data.features?.map((feature, index) => (
                <MotionBox
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                  <Box
                    p={6}
                    bg="whiteAlpha.200"
                    borderRadius="xl"
                    textAlign="center"
                    _hover={{
                      bg: 'whiteAlpha.300',
                      transform: 'scale(1.05)',
                    }}
                    transition="all 0.3s"
                  >
                    <Text
                      fontSize="lg"
                      fontWeight="700"
                      color="white"
                    >
                      {feature}
                    </Text>
                  </Box>
                </MotionBox>
              ))}
            </SimpleGrid>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default AIMasteryGuarantee;
